import { Injectable } from '@angular/core';
import { InvocaService } from 'src/app/base/services/invoca.service';

@Injectable({
  providedIn: 'root'
})
export class InfoTerritorialService {

  constructor(
    private invoke: InvocaService
  ) {}

  async getPaises(): Promise<any> {
    return await this.invoke.httpInvoke('infoTerritorial/getPaises');
  }

  async getRegiones(): Promise<any> {
    return await this.invoke.httpInvoke('infoTerritorial/getRegiones');
  }

  async getProvincias(): Promise<any> {
    return await this.invoke.httpInvoke('infoTerritorial/getProvincias');
  }

  async getComunas(): Promise<any> {
    return await this.invoke.httpInvoke('infoTerritorial/getComunas');
  }

  async getComunasRegion(params?: any): Promise<any> {
    return await this.invoke.httpInvoke('infoTerritorial/getComunasRegion', params);
  }

}
